import React from "react";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  IconButton,
  FormControl,
  Input,
} from "@mui/material";
import { Colors } from "../../../theme/colors";

interface JobInfoBoxProps {
  jobTitle: string;
  setJobTitle: (val: string) => void;
  campaignReferenceCode: string;
  setCampaignReferenceCode: (val: string) => void;
  campaignId: number;
  selectedEmployer: {
    employerName?: string;
    employerPic?: string;
    employerInitials?: string;
    employerBgColor?: string;
    employerColor?: string;
  };
  onChangeHiringManager: () => void;
}

const JobInfoBox: React.FC<JobInfoBoxProps> = ({
  jobTitle,
  setJobTitle,
  campaignReferenceCode,
  setCampaignReferenceCode,
  campaignId,
  selectedEmployer,
  onChangeHiringManager,
}) => {
  const inputStyle = {
    border: 0,
    borderBottomWidth: 1,
    outline: "none",
    borderRadius: 0,
    borderBottomColor: Colors.grey_border,
    padding: "8px 8px",
    fontSize: 14,
    "&:before, &:after": {
      display: "none",
    },
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <Typography
            color={Colors.black}
            fontSize={"14px"}
            variant="h6"
          >
            Job Title
          </Typography>
          <Input
            disableUnderline
            placeholder="Write the job title of the position you wish to fill"
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
            sx={inputStyle}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <FormControl fullWidth variant="standard">
          <Typography
            color={Colors.black}
            fontSize={"14px"}
            variant="h6"
          >
            Job Code
          </Typography>
          <Input
            disableUnderline
            placeholder="Enter reference code"
            value={campaignReferenceCode}
            onChange={(e) => setCampaignReferenceCode(e.target.value)}
            sx={inputStyle}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <FormControl fullWidth variant="standard">
          <Typography
            color={Colors.black}
            fontSize={"14px"}
            variant="h6"
          >
            Job ID
          </Typography>
          <Input disableUnderline value={campaignId} disabled sx={inputStyle} />
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <Typography
          color={Colors.black}
          fontSize={"14px"}
          variant="h6"
        >
          Hiring Manager
        </Typography>
        <Box
          onClick={onChangeHiringManager}
          sx={{
            backgroundColor: Colors.white,
            alignItems: "center",
            display: "flex",
            borderRadius: 2,
            width: "100%",
            cursor: "pointer",
          }}
        >
          <IconButton>
            <Avatar
              src={selectedEmployer?.employerPic || undefined}
              sx={{
                width: 36,
                height: 36,
                bgcolor:
                  selectedEmployer?.employerBgColor ??
                  Colors.Maximum_blue_purple,
                color: selectedEmployer?.employerColor?.includes("#")
                  ? selectedEmployer?.employerColor
                  : Colors.white,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {selectedEmployer?.employerInitials}
            </Avatar>
          </IconButton>
          <Typography variant="body1" fontWeight={500}>
            {selectedEmployer?.employerName?.toUpperCase() ??
              "Select Hiring Manager"}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default JobInfoBox;
